import { callZpayFunction } from '../../callZpayFunction';

// 로그인 페이지가 표시 됩니다.
// 로그인 상태가 변경되는 경우 기존 브라우저가 리로드 됩니다.
export const login = () => {
  callZpayFunction('login')();
};
